import { InjectionToken } from '@angular/core';

export interface ISplashModuleConfig {
    splashSelector: string;
}

export const SPLASH_CONFIGURATION = new InjectionToken<ISplashModuleConfig>('SPLASH_CONFIGURATION');

